import { updateOrderV2 } from '../../../../utility/sb-api/sb-api.service';
import {
  createHash,
  getOrderBody,
  getOrderErrorMessage,
  getOrderPathType,
} from '../../../../utility/util/util.service';
import { ORDER_STATUS_PENDING } from '../../../../utility/constants';
import {
  notification,
  notificationFormattedMessage,
} from '../../../../utility/notification/notification.service';

export const updateOrder = (
  me,
  order,
  checkout,
  cart,
  store,
  table,
  kiosk,
  setOrder,
  setOrderHash,
  intl,
) => {
  if (order?.status === ORDER_STATUS_PENDING) {
    const type = getOrderPathType(order.type);

    // V2: Build update body, falling back to existing order values for required fields
    const body = getOrderBody(checkout, cart, table, undefined, kiosk);
    // Ensure date fields from existing order are preserved if not in checkout state
    if (!body.pickupRequestedAt && order.pickupRequestedAt) {
      body.pickupRequestedAt = order.pickupRequestedAt;
    }
    if (!body.deliveryRequestedAt && order.deliveryRequestedAt) {
      body.deliveryRequestedAt = order.deliveryRequestedAt;
    }

    return updateOrderV2(type, order.id, body)
      .then((order) => {
        const hash = createHash({ cart: cart, checkout: checkout });
        setOrderHash(hash);
        setOrder(order);

        if (checkout?.discountCode) {
          notification('success', 'discountCodeSuccess');
        }

        return order;
      })
      .catch((err) => {
        notificationFormattedMessage('error', getOrderErrorMessage(err), {
          storeName: store?.name,
          error: err?.response?.data?.error,
        });
        console.log(err);
        throw err; // Re-throw so the calling component can handle it
      });
  } else {
    return Promise.reject('Order empty or already paid');
  }
};

export const confirmPaymentByType = (stripe, type) => {
  switch (type) {
    case 'card':
      return stripe.confirmCardPayment;
    case 'sepa_debit':
      return stripe.confirmSepaDebitPayment;
    case 'paypal':
      return stripe.confirmPayPalPayment;
    case 'klarna':
      return stripe.confirmKlarnaPayment;
    default:
      throw new Error('Unsupported payment method type: ' + type);
  }
};
